var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrainNoDirection = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 48,
  viewBox: "0 0 32 48"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 15.844,
  cy: 32.247,
  r: 15.753,
  fill: "#2E70FF",
  fillRule: "evenodd"
})));
export default SvgTrainNoDirection;